import './emoji-mart.css';
import data from '@emoji-mart/data';
import Picker from '@emoji-mart/react';
import React, { CSSProperties, useCallback } from 'react';

export interface MBEmojiPickerProps {
  onSelect(emoji: string): void;
  isMobileWeb?: boolean;
}

export function MBEmojiPicker({ onSelect, isMobileWeb }: MBEmojiPickerProps) {
  const select = useCallback((emoji: any) => onSelect(emoji.native), [onSelect]);
  // TODO: move this to a breakpoint in the adjacent css file
  const style: CSSProperties = {
    width: isMobileWeb ? '100%' : undefined,
  };

  return (
    <Picker
      data={data}
      set="native"
      autoFocus={true}
      theme="light"
      previewPosition="none"
      skinTonePosition="none"
      onEmojiSelect={select}
      style={style}
    />
  );
}
